import SvelteNgComponent from 'root/svelte-ng-components/SvelteNgComponent.js';
import Component from './RbGuestHeader.svelte';

export default {
  template: '<div></div>',
  controller: Ctrl
}

Ctrl.$inject = ['$element'];
function Ctrl($element){
  Object.assign(this, SvelteNgComponent(Component, $element[0]));
}
